import { useQueryClient } from "@tanstack/react-query"

import HorizontalImageNotification from "../../components/HorizontalImageNotification"
import { useAccountId, useGetGovtAppWizard } from "../../hooks"
import IMAGE from "../../images/paper-airplane.svg"
import { GovtApWizardType } from "@/types/govtAppWizard"

const MeetingNotification = () => {
  const queryClient = useQueryClient()
  const accountId = useAccountId()

  const { data: govtAppWizard, isLoading: govtAppWizardIsLoading } =
    useGetGovtAppWizard<GovtApWizardType, Error>(queryClient, accountId)

  if (
    govtAppWizardIsLoading ||
    govtAppWizard === undefined ||
    govtAppWizard?.selected_implementation !== "ncx_services"
  ) {
    return null
  }

  return (
    <HorizontalImageNotification
      image={IMAGE}
      heading="Your meeting is in the works!"
      variant="white"
      className="gap-4"
      closeable
    >
      <p>
        One of our representatives will be reaching out to you in the next 5
        days to discuss your plan and implementation options.
      </p>

      <p>
        While you're waiting, you can review our NCX post{" "}
        <a
          href="https://help.ncx.com/hc/en-us/articles/22771858287899-How-to-apply-for-government-programs-like-EQIP-CSP-and-CRP"
          className="link"
          target="_blank"
          rel="noopener noreferrer"
        >
          How to apply to government programs.
        </a>
      </p>
    </HorizontalImageNotification>
  )
}

export default MeetingNotification
